import LabelWeex from "./LabelWeex";
import {ElementStyles} from "./ElementStyles";
import SelectDateWeex from "./SelectDateWeex";

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    width: "100%"
  },
  container: {
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    // height: ElementStyles.height,
    display: "flex",
    alignItems: "center",
    paddingRight: 0
  }
};
export default function Select2DateWeex({
                                      label,
                                      onChange,
                                      containerStyle,
                                      value,
                                      ...props
                                    }){

  return (
    <LabelWeex style={{...styles.container, ...containerStyle}} {...props}>
      <div style={styles.grid}>
        <div style={{...styles.container, ...containerStyle, ...{paddingLeft: 0}}}>
          {label}
        </div>
        <SelectDateWeex
          onChange={onChange}
          value={value}
        />
      </div>
    </LabelWeex>
  );
};

